import debug from 'debug';
const log = debug('Sorting');

class Sorting {
	static by(property) {
		var sortOrder = 1;

		if(property[0] === "-") {
			sortOrder = -1;
			property = property.substr(1);
		}

		return function (a,b) {
			if (typeof a[property] === 'boolean' || typeof a[property] === 'number') {
				var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
			} else {
				var result = ((a[property].toLowerCase()) < (b[property].toLowerCase())) ? -1 : ((a[property].toLowerCase()) > (b[property].toLowerCase())) ? 1 : 0;
			}
			return result * sortOrder;
		}
	}
}

export default Sorting;

